import FJAiVideoDubInput from '../view/FJAiVideoDubInput';
import useAIListSideModelData from '../../../../hooks/useAIListSideModelData';
import FJActionAiVideoDub from '../../../../redux/action/FJActionAiVideoDub';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { setSliceIsDraggingFileAction } from '../../../../redux/slices/FJSliceCommon';
import PropTypes from 'prop-types';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';

const FJAiVideoDubInputContainer = ({ disable }) => {
    useLocalStore();
    const dispatch = useDispatch();

    const { showModal } = useAIListSideModelData();
    const videoInfo = useSelector(state => {
        const trimInfo = state.aiVideoDub.trimInfo;
        const videoInfo = state.aiVideoDub.videoInfo;
        return {
            ...trimInfo,
            ...videoInfo,
        };
    });
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const isUploadFileLoading = useSelector(state => state.aiVideoDub.isUploadFileLoading);

    const uploadVideo = useCallback(
        file => {
            dispatch(FJActionAiVideoDub.uploadVideoAction(file));
        },
        [dispatch],
    );

    const _onCrop = useCallback(() => {
        dispatch(FJActionAiVideoDub.enterTrimVideoAction());
    }, [dispatch]);

    const _onDelete = useCallback(() => {
        dispatch(FJActionAiVideoDub.deleteVideoAction());
    }, [dispatch]);

    const setIsDraggingFile = useCallback(
        value => {
            dispatch(setSliceIsDraggingFileAction(value));
        },
        [dispatch],
    );

    const _openMediaLibrary = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    };

    return (
        <FJAiVideoDubInput
            showModal={showModal}
            onUploadVideo={uploadVideo}
            videoInfo={videoInfo}
            onCrop={_onCrop}
            onDelete={_onDelete}
            isDraggingFile={isDraggingFile}
            setIsDraggingFile={setIsDraggingFile}
            disable={disable}
            isUploadFileLoading={isUploadFileLoading}
            openMediaLibrary={_openMediaLibrary}
        />
    );
};

FJAiVideoDubInputContainer.propTypes = {
    disable: PropTypes.bool,
};

export default FJAiVideoDubInputContainer;
